/**
 * FlowAI Skill-Liste — Workspace-Skills + Globals.
 *
 * @page /flowai/skills
 * @since v2.484.0
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader, Card, Button, Badge } from '../../components/ui';
import { IconCases } from '../../components/Icons';
import FlowAIBreadcrumb from '../../components/flowai/FlowAIBreadcrumb';

const API = import.meta.env.VITE_API_URL || '';

export default function FlowAISkillList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    fetch(`${API}/api/flowai/skills`, { credentials: 'include' })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : (d?.skills ?? [])))
      .catch(() => setRows([]));
  }, []);
  return (
    <div className="p-6">
      <FlowAIBreadcrumb trail={[{ label: 'Skills' }]} />
      <PageHeader
        title="Skills"
        subtitle="Atomare AI-Bausteine (Klassifikation, Generation, ...)"
        actions={<Button onClick={() => navigate('/flowai/skills/new')}>+ Neu</Button>}
      />
      <Card padding="sm">
        {rows.length === 0 ? (
          <div className="p-12 text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--bg-inset,#F8F9FC)] mb-3">
              <IconCases className="w-6 h-6 text-[var(--text-tertiary,#6B7280)]" />
            </div>
            <div className="text-sm font-medium mb-1">Noch keine Skills</div>
            <div className="text-[12px] text-[var(--text-tertiary,#6B7280)] mb-3">Skills sind atomare AI-Bausteine — Klassifikation, Generation, Zusammenfassung.</div>
            <Button onClick={() => navigate('/flowai/skills/new')}>+ Ersten Skill anlegen</Button>
          </div>
        ) : (
          <div className="divide-y divide-[var(--border-subtle,#E5E7EB)]">
            <div className="px-3 py-2 grid grid-cols-[40px_1fr_120px_80px_140px_100px] gap-3 text-[11px] font-medium uppercase tracking-wide text-[var(--text-tertiary,#6B7280)] bg-[var(--bg-inset,#F8F9FC)]">
              <span>#</span>
              <span>Name</span>
              <span>Slug</span>
              <span>Version</span>
              <span>Scope</span>
              <span></span>
            </div>
            {rows.map((s) => (
              <div
                key={s.id}
                className="px-3 py-2.5 grid grid-cols-[40px_1fr_120px_80px_140px_100px] gap-3 items-center text-sm hover:bg-[var(--bg-inset,#F8F9FC)] cursor-pointer"
                onClick={() => navigate(`/flowai/skills/${s.id}`)}
              >
                <span className="font-mono text-[var(--text-tertiary,#6B7280)]">#{s.id}</span>
                <span className="font-medium truncate">{s.name}</span>
                <code className="text-[11px] text-[var(--text-tertiary,#6B7280)] truncate">{s.slug}</code>
                <span className="text-[12px] text-[var(--text-secondary,#4B5563)]">{s.version ? `v${s.version}` : '—'}</span>
                <span>
                  <Badge variant={s.workspace_id ? 'default' : 'success'}>{s.workspace_id ? `WS ${s.workspace_id}` : 'global'}</Badge>
                </span>
                <span className="text-right">
                  <Button variant="ghost" onClick={(e) => { e.stopPropagation(); navigate(`/flowai/skills/${s.id}`); }}>Öffnen</Button>
                </span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
